import Vue from 'vue'
import App from './App.vue'


import Home from './App.vue'
import Milestones from './components/Milestones.vue'
import EditMilestones from './components/EditMilestones.vue'
import Game501 from './components/Game501.vue'
import NotFound from './NotFound.vue'
import AdminArea from './components/AdminArea.vue'
import Leaderboard from './components/Leaderboard.vue'
import PlayerOptions from './components/PlayerOptions.vue'
import PlayerMilestones from './components/PlayerMilestones.vue'
import PatchNotes from './components/PatchNotes.vue'

const routes = {
  '/': Milestones,
  '/editmilestones': EditMilestones,
  '/game501': Game501,
  '/admin': AdminArea,
  '/leaderboard': Leaderboard,
  '/playeroptions': PlayerOptions,
  '/playermilestones': PlayerMilestones,
  '/patchnotes': PatchNotes
}


// FA
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCog, faPowerOff, faUserPlus, faHome, faPlus, faBackspace, faCheck, faTrophy, faStar, faMedal, faSmile, faUserCog, faArrowUp, faInfo, faInfoCircle, faCrown, faSkull, faBan, faDragon, faRobot, faUtensilSpoon, faUserCheck } from '@fortawesome/free-solid-svg-icons'
import { faFileAlt, faGrinSquintTears } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faPowerOff, faBackspace, faCheck, faCog, faUserPlus, faHome, faPlus, faTrophy, faStar, faMedal, faSmile, faUserCog, faArrowUp, faInfo, faInfoCircle, faFileAlt, faGrinSquintTears, faCrown, faSkull, faBan, faDragon, faRobot, faUtensilSpoon, faUserCheck)


Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = false

// new Vue({
//   render: h => h(App),
// }).$mount('#app')





// const Home = { template: '<p>home page</p>' }
// const About = { template: '<p>about page</p>' }



new Vue({
	el: '#app',
	data: {
		currentRoute: window.location.pathname
	},
	computed: {
		ViewComponent () {
			return routes[this.currentRoute] || NotFound
		}
	},
	render (h) { return h(this.ViewComponent) }
})